import { ADD_APP_REVIEW_DATA, UPDATE_APP_REVIEW_DATA } from "../../actions/actionTypes/appReview";

const initialState = {
    username: "",
    userReview: "",
    dateCreated: "",
    dateUpdated: "",
    nextRunDays: 0,
  };

  export function appReview(state = initialState, action: any) {
    switch (action.type) {
      case ADD_APP_REVIEW_DATA: {
        const { username, userReview, dateCreated, dateUpdated, nextRunDays } = action.payload;
        return {
          ...state,
          username,
          userReview,
          dateCreated,
          dateUpdated,
          nextRunDays
        };
    }
    case UPDATE_APP_REVIEW_DATA: {
        const { userReview, dateCreated, dateUpdated } = action.payload;
        return {
          ...state,
          userReview,
          dateCreated,
          dateUpdated,
        };
    }
      default:
        return state;
    }
  }
  